import { Send } from 'lucide-react';
import { useTranslation } from 'react-i18next';

// Extraído de OpDetailPanel.jsx (02.3-client.md paso b) -- el tab "Comentarios", agrupado por
// etapa (`allStages`/`commentsByStage`/`accordionKey` ya vienen calculados por el container vía
// `useMemo`, no se recalculan acá). Puramente presentacional: sin `clientApi`/hooks de
// `useClient*`/React Query -- el envío real (`sendComment`) y su estado (`sending`) siguen
// siendo dueños del container.
export default function OpCommentsTab({
    comments, allStages, commentsByStage, accordionKey, allUsers,
    newComment, setNewComment, sendComment, sending,
}) {
    const { t } = useTranslation('client');

    return (
        <div className="op-panel-body op-comments-body" style={{ display: 'flex', flexDirection: 'column', height: '100%', padding: 'var(--space-3)', boxSizing: 'border-box' }}>
            <div style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
                {comments.length === 0 && (
                    <div style={{ opacity: 0.4, fontSize: 12, textAlign: 'center', marginTop: 'var(--space-6)' }}>
                        {t('detailPanel.comments.empty')}
                    </div>
                )}
                {allStages.map(stage => {
                    const key = accordionKey(stage);
                    const stageComments = (commentsByStage[key] || [])
                        .slice()
                        .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
                    if (stageComments.length === 0) return null;
                    return (
                        <div key={key} style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-2)' }}>
                            <div style={{ fontSize: 10, fontWeight: 600, opacity: 0.5, letterSpacing: '0.03em' }}>{stage.title}</div>
                            {stageComments.map(c => {
                                const author = allUsers.find(u => u.id === c.author_id);
                                const authorName = author?.nick || t('detailPanel.comments.unknownUser');
                                return (
                                    <div key={c.id} style={{ display: 'flex', gap: 'var(--space-2)' }}>
                                        <img
                                            loading="lazy"
                                            src={author?.['link-profile-img'] || `https://ui-avatars.com/api/?name=${encodeURIComponent(authorName)}&background=random`}
                                            alt={authorName}
                                            style={{ width: 28, height: 28, borderRadius: '50%', flexShrink: 0, objectFit: 'cover' }}
                                        />
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div style={{ display: 'flex', gap: 'var(--space-2)', alignItems: 'baseline' }}>
                                                <span style={{ fontWeight: 600, fontSize: 12 }}>{authorName}</span>
                                                <span style={{ fontSize: 10, opacity: 0.35, marginLeft: 'auto' }}>
                                                    {new Date(c.created_at).toLocaleString()}
                                                </span>
                                            </div>
                                            <div style={{ fontSize: 13, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{c.content}</div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
            <div style={{ display: 'flex', gap: 'var(--space-2)', marginTop: 'var(--space-2)', borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 'var(--space-2)' }}>
                <input
                    type="text"
                    value={newComment}
                    onChange={e => setNewComment(e.target.value)}
                    onKeyDown={e => { if (e.key === 'Enter' && !sending) sendComment(); }}
                    placeholder={t('detailPanel.comments.placeholder')}
                    style={{ flex: 1, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 'var(--radius-md)', padding: 'var(--space-2) var(--space-3)', color: '#fff', fontSize: 13 }}
                />
                <button
                    onClick={sendComment}
                    disabled={sending || !newComment.trim()}
                    className="op-panel-tab"
                    style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-1)' }}
                >
                    <Send size={14} /> {t('detailPanel.comments.send')}
                </button>
            </div>
        </div>
    );
}
